// @ts-nocheck
import { AGENT_CALL_CONNECT_LIST } from "@/service/url";
export const INTERNAL_HOSTS = [
  "localhost",
  "voiz.nspl.cloud",
  "voicebox.nspl.cloud",
  "stgvoice.nspl.cloud",
  "stgvoice-voicebot.nspl.cloud",
  "stgvoice2.nspl.cloud",
  // "ucs.nspl.cloud",
  "ucs.expressivr.com",
];

export const BACKEND_API_BASE_URL = (() => {
  // Dev override: set VITE_BACKEND_API_BASE_URL in .env.local to skip the
  // localhost:3900 backend and point at a remote API instead. Empty string
  // and "undefined" both fall through to the hostname-based defaults below.
  const envOverride =
    typeof import.meta !== "undefined" && import.meta.env
      ? import.meta.env.VITE_BACKEND_API_BASE_URL
      : null;
  if (envOverride && String(envOverride).trim()) {
    return String(envOverride).trim();
  }

  if (typeof window === "undefined") {
    return "https://voiceboxapi.nspl.cloud/api";
  }

  const { hostname } = window.location;

  if (hostname === "localhost") {
    return "http://localhost:3900/api";
  }

  if (hostname === "voice.expressivr.com") {
    return "https://api-voice.expressivr.com/api";
  }

  if (hostname === "voiz.nspl.cloud") {
    return "https://voizapi.nspl.cloud/api";
  }

  if (hostname === "voicebox.nspl.cloud") {
    return "https://voiceboxapi.nspl.cloud/api";
  }

  if (hostname === "stgvoice.nspl.cloud") {
    return "https://stgvoice.nspl.cloud/stg/api";
  }

  if (hostname === "stgvoice-voicebot.nspl.cloud") {
    return "https://stgvoice-voicebot.nspl.cloud/stg/api";
  }

  if (hostname === "stgvoice2.nspl.cloud") {
    return "https://stgvoice.nspl.cloud/stg/api";
  }

  // if (hostname === "ucs.nspl.cloud") {
  //   return "https://ucs.nspl.cloud/api";
  // }

  if (hostname === "ucs.expressivr.com") {
    return "https://ucs.expressivr.com/api";
  }

  return "https://stgvoice.nspl.cloud/stg/api";
})();


export const KNOWLEDGE_BASE_API_PATH = "/v2/knowledge-bases";

export const AI_AGENT_API_PATH = "/v2/ai-agents";

// Max upload size 
export const KNOWLEDGE_BASE_MAX_FILE_SIZE_BYTES = 100 * 1024 * 1024; // 100 MB


export const KNOWLEDGE_BASE_ALLOWED_EXTENSIONS = ["pdf", "doc", "docx", "txt"];
export const KNOWLEDGE_BASE_ACCEPT = KNOWLEDGE_BASE_ALLOWED_EXTENSIONS.map((ext) => `.${ext}`).join(",");
export const KNOWLEDGE_BASE_INVALID_FILE_MESSAGE = "Invalid file type. Only PDF, DOC, DOCX and TXT files are allowed.";

export const KNOWLEDGE_BASE_TYPE_OPTIONS = [{ value: "general", label: "General" }];

export const TTS_CONVERSION_URL_BY_ENV = {
  development: "https://cloudtts.nspl.cloud/texttospeech/single",
  staging: "https://cloudttsexpress.nspl.cloud/texttospeech/single",
  production: "https://ucs.expressivr.com/texttospeech/single",
};


export const TTS_CONVERSION_URL = (() => {
  const host =
    (typeof window !== "undefined" && window.location && window.location.hostname) || "";
  const usesCloudTts = ["localhost", "stgvoice", "voicebox"].some((h) =>
    host.includes(h)
  );
  return usesCloudTts
    ? TTS_CONVERSION_URL_BY_ENV.development
    : TTS_CONVERSION_URL_BY_ENV.staging;
})();

let ttsConversionUrlPromise = null;
export const getTtsConversionUrl = async () => {
  if (!ttsConversionUrlPromise) {
    ttsConversionUrlPromise = (async () => {
      try {
        const { getApiCall } = await import("@/service/httpCall");
        const resp = await getApiCall(AGENT_CALL_CONNECT_LIST);
        return TTS_CONVERSION_URL_BY_ENV[resp?.node_env] || TTS_CONVERSION_URL;
      } catch {
        return TTS_CONVERSION_URL;
      }
    })();
  }
  return ttsConversionUrlPromise;
};

// Resolve API origin. When BACKEND_API_BASE_URL is relative ("/api" — the
// Vite-proxied localhost case) `new URL(...)` throws, so fall back to the
// current page origin. Sockets and the proxypass surface hang off this.
const resolvedApiOrigin = (() => {
  try {
    return new URL(BACKEND_API_BASE_URL).origin;
  } catch {
    return typeof window !== "undefined" && window.location
      ? window.location.origin
      : "";
  }
})();

export const PROXY_URL = `${resolvedApiOrigin}/proxypass/`;

// Call-engine SIP traces (Tushar's sipDetails service). Same host as the GUI
// except localhost / stgvoice2, which share staging sipDetails.
export const SIP_DETAILS_ORIGIN = (() => {
  if (typeof window === "undefined") {
    return "https://stgvoice.nspl.cloud";
  }
  const { hostname, origin } = window.location;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "https://stgvoice.nspl.cloud";
  }
  if (hostname === "stgvoice2.nspl.cloud") {
    return "https://stgvoice.nspl.cloud";
  }
  return origin;
})();

export const callEngineTracesUrl = (callSid) =>
  `${SIP_DETAILS_ORIGIN}/sipDetails/api/v1/calls/${encodeURIComponent(String(callSid || "").trim())}/traces`;


export const STORAGE_BASE_URL = (() => {
  if (typeof window !== "undefined" && window.location.hostname === "localhost") {
    return "http://localhost:3009/";
  }

  return `${resolvedApiOrigin}/storage/`;
})();

export const STORAGE_API_BASE_URL = (() => {
  if (typeof window !== "undefined" && window.location.hostname === "localhost") {
    return "http://localhost:3009/api/";
  }

  return `${resolvedApiOrigin}/storage/api/`;
})();

export const SOCKET_BASE_URL = resolvedApiOrigin;
export const SOCKET_AGENT_PATH = "/agent/socket.io";
export const SOCKET_ADMIN_PATH = "/admin/socket.io";
export const SOCKET_AUTH_TOKEN = "use-any-auth-key";

export const CLIENT_SOURCE_HEADER = "x-client-source";
export const CLIENT_SOURCE =
  "25eaf75994c239c5bb45d42d14c2ad8f43795b33b63b742372598c4c9dd6aa2f";

export const SOCKET_CALL_EVENTS = {
  DIALING: "DIALING",
  RINGING: "RINGING",
  ANSWERED: "ANSWERED",
  HANGUP: "HANGUP",
};
export const SOCKET_AGENT_EVENTS = {
  AGENT_BUSY: "AGENT_BUSY",
  AGENT_FREE: "AGENT_FREE",
  AGENT_EVENT: "AGENT_EVENT",
};

export const USER_STATUS = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

export const PROMPT_STATUS = {
  APPROVED: 1,
  REJECT: 2,
  PENDING: 0,
}

export const USER_CREDITS_ACTION = {
  ADD: "addition",
  DEDUCT: "deduction"
}


export const LICENCE_LABEL = {
  channel: "Channel",
  company: "Company",
  cps: "CPS",
  mobile: "Mobile License",
  live_agent: "Live Agent",
  role_ccagent: "Total Agent",
  role_teamlead: "Total Team Lead",
  role_ccadmin: "Call Centers",
  demo_live_agents_per_reseller_company: "Demo Live Agents (Reseller)",
  ai_agent: "AI Agents",
  ai_agent_live_channel: "AI Agent Live Channels",
};

export const TTS_CREDITS_ACTION = {
  ADDITION: "TTS_ADDITION",
  DEDUCTION: "TTS_DEDUCTION"
}

export const AI_AGENT_CREDITS_ACTION = {
  ADDITION: "AI_AGENT_ADDITION",
  DEDUCTION: "AI_AGENT_DEDUCTION"
}

export const USER_STATUS_LABEL = ["Active", "Inactive"];

export const USER_ROLES = {
  RESELLER: "role_reseller",
  SUPERADMIN: "role_sadmin",
  COMPANY_ADMIN: "role_cadmin",
  CALL_CENTRE_ADMIN: "role_ccadmin",
  CALL_CENTRE_TEAM_LEAD: "role_ccteamlead",
  CALL_CENTRE_AGENT: "role_ccagent",
  CALL_CENTRE: "role_call_centre",
  SUB_SUPERADMIN: "role_sub_superadmin"
};

export const NUMBER_OPS_CREATE_ROLES = [USER_ROLES.SUPERADMIN, USER_ROLES.SUB_SUPERADMIN, USER_ROLES.CALL_CENTRE_ADMIN];
export const NUMBER_OPS_DND_ROLES = [USER_ROLES.SUPERADMIN, USER_ROLES.SUB_SUPERADMIN];

export const USER_ROLES_MAP = {
  [USER_ROLES.RESELLER]: "Reseller",
  [USER_ROLES.SUPERADMIN]: "Superadmin",
  [USER_ROLES.COMPANY_ADMIN]: "Company user",
  [USER_ROLES.CALL_CENTRE_ADMIN]: "Call Centre Admin User",
  [USER_ROLES.CALL_CENTRE_TEAM_LEAD]: "Call Centre Admin Team Lead",
  [USER_ROLES.CALL_CENTRE_AGENT]: "Call Centre Admin Agent",
  [USER_ROLES.CALL_CENTRE]: "Call Centre",
  [USER_ROLES.SUB_SUPERADMIN]: "Sub Superadmin"
};

export const USER_ROLES_MAP_PROFILE = {
  [USER_ROLES.RESELLER]: "Reseller",
  [USER_ROLES.SUPERADMIN]: "Superadmin",
  [USER_ROLES.COMPANY_ADMIN]: "Company",
  [USER_ROLES.CALL_CENTRE_ADMIN]: "Call Centre",
  [USER_ROLES.CALL_CENTRE_TEAM_LEAD]: "Team Lead",
  [USER_ROLES.CALL_CENTRE_AGENT]: "Agent",
  [USER_ROLES.CALL_CENTRE]: "Call Centre",
  [USER_ROLES.SUB_SUPERADMIN]: "Sub Superadmin"
};

export const PERMISSION_TYPES = {
  CREATE: "permission_create",
  READ: "permission_read",
  UPDATE: "permission_update",
  DELETE: "permission_delete",
};

export const CONTACT_PAGE_SIZES = [10, 25, 50, 100, 500, 1000, 2000];

export const ROUTES = {
  LOGIN: "auth/sign-in",
  VERIFY_EMAIL: "auth/verify-email",
  DASHBOARD: "dashboard",
  AGENT_REALTIME_STATS: "agent-realtime-stats",
  SWITCH_ACCOUNT_LOADER: "/switch-account-loader",
  USERS: {
    EDIT: "users/:id",
    CREATE: "users/create",
    LIST: "users",
    RESELLERALLOCATE: 'allocate/:id/:currentId/:role',
    RESET_PASSWORD: "users/reset/:id"
  },
  CALL_CENTRE_AGENTS: {
    LIST: "call-centre-agents",
  },
  COMPANIES: {
    LIST: "companies",
    EDIT: "companies/:id",
    CREATE: "companies/create",
  },
  CALL_CENTRES: {
    LIST: "call-centres",
    ANALYTICS: "call-centres/analytics",
    CREATE: "call-centres/create",
    EDIT: "call-centres/:id",
    USERS: {
      LIST: "call-centres/:id/users",
      CREATE: "call-centres/:id/users/create",
      EDIT: "call-centres/:id/users/:uid",
    },
  },
  TRUNKS: {
    EDIT: "trunks/:id",
    CREATE: "trunks/create",
    LIST: "trunks",
    DELETE: "trunks/:id",
  },

  VOICEMAILS: {
    LIST: "voicemails",
  },

  NUMBERS: {
    EDIT: "numbers/:id",
    CREATE: "numbers/create",
    LIST: "numbers",
    DELETE: "numbers/:id",
    NUMBER_FILE_LIST: 'number-filelist/',
    NUMBER_FILE_DELETE: 'number-filelist/delete',
    STATUS_CHANGE_ACTION: 'number-status-change/',
    DID_MAPPING: 'numbers/did-mapping',
    ALLOCATED_NUMBERS: 'numbers/allocated/',
    DID_HISTORY: 'numbers/did-history/'

  },
  VOICE_PLAN: {
    CREATE: "voice-plan/create",
    LIST: "voice-plan",
    EDIT: "voice-plan/edit/:id",
    DETAIL: "voice-plan/view/:id",
  },

  FLASH_MESSAGE: {
    CREATE: "flash-message/create",
    LIST: "flash-message",
  },

  REALTIME: {
    LIST: "realtime",
    LIVE_CALLS: "realtime/live-calls",
  },


  REMARKS: {
    LIST: "remark-status-list",
    EDIT: "remark-status-edit/:id",
    ADD: "remark-status-add",
    REMARKS: 'remarks'
  },

  AGENT_ANNOUNCEMENT: {
    LIST: "agent-announcements",
    CREATE: "agent-announcements/create",
    EDIT: "agent-announcements/edit/:id",
    DELETE: "agent-announcements/delete",
  },


   NOTIFICATION: {
    LIST: "notifications",
    CREATE: "notifications/create",
    EDIT: "notifications/edit/:id",
    DELETE: "notifications/delete",
    ASSIGNMENTS: "notifications/assignments",
  },

  CALL_SCRIPT: {
  LIST:   'call-scripts',
  CREATE: 'call-scripts/create',
  EDIT:   'call-scripts/edit/:id',
  DELETE: 'call-scripts/delete/:id',
},

  RELEASE_CENTER: {
    LIST: 'release-center',
  },

  AGENT_IDLE_STATS: {
    LIST: "agent-idle-stats",
  },

  MANAGE_GROUPS: {
    CREATE: "create-group",
    GROUP_LIST: "group-list",
    BULK_ADD: "group-bulk-add",
    BULK_DELETE: "group-bulk-delete"
  },

  MANAGE_LOCATIONS: {
    CREATE: "create-location",
    LOCATION_LIST: "location-list",
    BULK_ADD: "location-bulk-add",
    BULK_DELETE: "location-bulk-delete"
  },

  COUNTRY_CODE_DIRECTIONS: {
    LIST: "country-code-directions",
    CREATE: "country-code-directions/create",
    EDIT: "country-code-directions/edit/:id",
  },

  MANAGE_DIALERS: {
    CREATE: "create-dialer",
    EDIT: "create-dialer/:id",
    DIALER_LISTING: "dialer-list"
  },

  DESPOSITION: {
    ADD: "desposition-add"
  },

  DISPOSITION_FORMS: {
    LIST: "disposition-forms",
    CREATE: "disposition-forms/create",
    EDIT: "disposition-forms/edit/:id",
  },

  DISPOSITION_FOLLOW_UPS: {
    LIST: "disposition-follow-ups",
  },

  CALL_QUALITY_FEEDBACK: "call-quality-feedback",

  IVR: {
    EDIT: "call-centres/:cid/ivr/:id",
    CREATE: "call-centres/:cid/ivr/create",
    LIST: "call-centres/:cid/ivr",
    DELETE: "call-centres/:cid/ivr/:id",
    VIEW: "call-centres/:cid/ivr/view",
    ADD_VOICE: "call-centres/add-voice",
    BULK_ADD_VOICE: "call-centres/add-voice/bulk",
    EDIT_VOICE: "call-centres/edit-voice/:id",
    VIEW_VOICE: "call-centres/view-voice",
    VIEW_TTS: "call-centres/view-tts",
    INBOUND_CALLS: 'inbound-calls/:cid',
    INCOMING_SUMMARY: "call-centres/incoming-summary",
    OUTCOMING_SUMMARY: "call-centres/outcoming-summary",
    UPDATE_INBOUND_CALLS: 'update-inbound-calls/:cid',
    DOWNLOAD_REPORT: "call-centres/download-report",
    CDR_REPORT: "call-centres/cdr-report",
    AGENT_PERFORMANCE_REPORT: "call-centres/agent-performance-report",
    VIEW_DETAIL: "/did-report/:did/:startDate/:endDate"
  },
  OPERATORS: {
    LIST: "operators",
  },
  DATA_CENTER: {
    EDIT: "data-center/:id",
    CREATE: "data-center/create",
    LIST: "data-center",
    DELETE: "data-center",
  },
  SERVER_MANAGEMENT: {
    EDIT: "server-management/:id",
    CREATE: "server-management/create",
    LIST: "server-management",
    DELETE: "server-management",
  },
  MODULE: {
    EDIT: "module/:id",
    CREATE: "module/create",
    LIST: "module",
    DELETE: "module/:id",
  },
  ACL_SETTING: {
    CREATE: "acl-settings/create",
    HISTORY: "acl-settings/history",
    LOCK_AUDIT: "acl-settings/lock-audit",
    LIST: "acl-settings",
    EDIT: "acl-settings/:id",
    DELETE: "acl-settings/:id"
  },
  JOURNEY_OPERATION: {
    LIST: "journey-operation",
  },
  AGENT_LEADS: {
    ADMIN_LIST: "agent-leads",
    HISTORY: "agent-leads/history",
    DETAIL: "agent-leads/:id",
    AGENT_LIST: "my-leads",
  },
  MANAGE_AGENTS: {
    AGENTS: "agents",
    CREATE_AGENT: "create-agent",
    CREATE_AGENT_GROUP: "create-agent-group",
    AGENT_GROUP_LIST: "agent-group-list",
    AGENT_GROUP_ANALYTICS: "call-group-analytics",
    EXTENSION: "extension",
    CREATE_EXTENSION: "create-extension",
    BULK_CREATE_EXTENSION: "bulk-create-extension",
    EDIT_EXTENSION: "edit-extension/:id",
    GROUP_SETTINGS: "group-settings/:id",
    EDIT_AGENT: "agents/edit-agent/:id",
    AGENT_FILE_LIST: "agent-filelist/"

  },
  MANAGE_QUEUES: {
    CREATE: "create-queue",
    QUEUES: "queus"
  },
  VOICE_LIBRARY: {
    MANAGE_PROMPTS: "manage-prompts",
    VIEW_VOICE_FILES: "view-voice-files",
    MOH_MANAGEMENT: "moh-management",
    ADD_MOH: "add-moh",
  },
  AI_AGENT: {
    AGENTS: "ai-agent/agents",
    KNOWLEDGE_BASE_LIST: "ai-agent/knowledge-base",
    KNOWLEDGE_BASE_CREATE: "ai-agent/knowledge-base/create",
    BUILDER: "ai-agent/builder",
    BUILDER_V2: "ai-agent/builder-v2",
  },
  CREDIT_HISTORY: "credit-history",
  CREDIT_SUMMARY: "credit-summary",
  VOICE_CREDITS_LOGS: "voice-credits-logs",
  TTS_CREDITS_LOGS: "tts-credits-logs",
  AI_AGENT_CREDITS_LOGS: "ai-agent-credits-logs",
  CAMPAIGNS: {
    LIST: "campaigns",
    SUMMARY: "campaigns-summary",
    CREATE: "create-campaign",
    DETAIL: "campaigns-detail/:id",
    REPORT: "campaigns-report/:id",
    DUPLICATE: "create-campaign/:duplicate_camp_id",
    EDIT: "edit-campaign/:edit_camp_id",
  },
  BREAKS: {
    LIST: "breaks",
    CREATE: "create-break",
    UPDATE: "breaks/:id",
    RECORDS: "agent-break-records"
  },
  WEBHOOK: {
    LIST: "webhook",
    CREATE: "create-webhook",
    UPDATE: "webhook/:id"
  },
  SMSWEBHOOK: {
    LIST: "sms-webhook",
    CREATE: "create-sms-webhook",
    UPDATE: "sms-webhook/:id"
  },
  APIWEBHOOK: {
    LIST: "api-webhook",
    CREATE: "create-api-webhook",
    UPDATE: "api-webhook/:id"
  },
  MANAGE_WEBHOOK: {
    LIST: "manage-webhook",
    CREATE: "manage-webhook/create",
    EDIT: "manage-webhook/create/:id"
  },
  PROFILE: "profile",
  CONTACTGROUP: {
    LIST: "contact-group",
    CREATE: "contact-group/:id/create-contact",
    UPDATE: "contact-group/:id",
    IMPORT_MEMBERS: "contact-group/:id/import-members",
    ALL_CONTACTS: "all-contacts",
    CREATE_ALL_CONTACTS: "create-all-contacts",
    EDIT_CONTACT: "all-contacts/:id/edit",
    CUSTOM_FIELD_TEMPLATES: "contact-custom-fields",
    CREATE_CUSTOM_FIELD_TEMPLATE: "contact-custom-fields/create",
  },
  TTS: {
    CREATE: "create-tts",
    LIST: "tts-list",
    VOICE_PROFILE: "voice-profile",
    VOICE_PROFILE_LIST: "voice-profile-list",
  },
  TTSPLANS: {
    CREATE: "create-tts-plans",
    LIST: "tts-plan-list"
  },
  DEMO_ACCOUNT_SETTINGS: {
    LIST: "demo-account-settings",
    CREATE: "demo-account-settings/create",
    EDIT: "demo-account-settings/edit/:id"
  },
  LICENCE_HISTORY: {
    LIST: "licence-history-list"
  },
  CALL_QUALITY: {
    LIST: "call-quality"
  },
  BACKEND_LOGS: "backend-logs",
  API_METRICS: "api-metrics",
  AGENT_ACTIVITY_TRACKING: "agent-activity-tracking",
  SESSION_REPLAY: {
    LIST: "session-replay",
    REPLAY: "session-replay/watch/:id",
    ANALYTICS: "session-replay/analytics",
    RECORDING_SETTINGS: "session-replay/recording-settings",
  },
  NUMBER_OPERATIONS: {
    MANAGE_BLACKLIST_DND: "number-operations/manage-blacklist-dnd",
    VIEW_BLACKLIST_DND: "number-operations/view-blacklist-dnd",
    SEARCH_DND_BLIST: "number-operations/search-dnd-blist",
  },
  VOICE_BLACKLIST: {
    ADD: "voice-blacklist/add",
    BULK: "voice-blacklist/bulk",
    VIEW: "voice-blacklist/view",
  },
};

export const TRUNK_AUTH_TYPE_REGISTRATION = 1;
export const TRUNK_AUTH_TYPE_IP = 2;
export const TRUNK_AUTH_TYPES = [
  { label: "IP", value: TRUNK_AUTH_TYPE_IP },
  { label: "Registration", value: TRUNK_AUTH_TYPE_REGISTRATION },
];

export const OPERATOR_TYPES = [
  { label: "Airtel", value: 1 },
  { label: "Jio", value: 2 },
];

export const CONTENT_STATUS = [
  { label: "Active", value: 1 },
  { label: "Inactive", value: 0 },
];

export const NUMBER_COST_MIN = 0;
export const NUMBER_COST_MAX = 10000;

export const NUMBERS_FORMAT_INDIVIDUAL = "INDIVIDUAL";
export const NUMBERS_FORMAT_FILE = "FILE";
export const NUMBERS_FORMAT_TYPES = [
  { label: "INDIVIDUAL", value: NUMBERS_FORMAT_INDIVIDUAL },
  { label: "FILE", value: NUMBERS_FORMAT_FILE },
];

export const NUMBER_ROUTING_TYPE =[
  {label:"INCOMING", value:"incoming"},
  {label:"OUTGOING", value:"outgoing"},
  {label:"BOTH", value:"both"},
]

export const NUMBERS_TYPES_DID = "DID";
export const NUMBERS_TYPES_VMN = "VMN";
export const NUMBERS_TYPES_TOLFREE = "TOLL FREE";
export const NUMBERS_TYPES = [
  { label: "DID", value: NUMBERS_TYPES_DID },
  { label: "VMN", value: NUMBERS_TYPES_VMN },
  { label: "TOLL FREE", value: NUMBERS_TYPES_TOLFREE },
]
export const BULK_UPDATE_DID = ['DID', 'Category', 'Currency', 'Country Code', 'State Code', 'Cost', 'Operator', 'Status', "TrunkId", 'Number Routing'];
export const BULK_UPDATE_OTHERS = ['DID', 'Currency', 'Country Code', 'Operator', 'Status', 'Number Routing'];

export const UPLOAD_NUMBER_DID = ['Country Code', 'State Code', 'DID', 'Cost', 'Operator', 'Number Routing', 'TrunkId'];
export const SAMPLE_DATA_DID = [{ 'Country Code': 'IN', 'State Code': "HR", 'DID': '9991066739', 'Cost': '100', 'Operator': 'JIO', 'Number Routing': 'incoming', 'TrunkId': '1' }];
export const SAMPLE_DATA_DID_UPDATE = [{ 'DID': '9991066739', 'Category': "Free", 'Currency': 'INR', 'Country Code': 'IN', 'State Code': "HR", 'Cost': '0', 'Operator': 'JIO', 'Status': "1", "TrunkId": "1", 'Number Routing': 'incoming' }];

export const UPLOAD_NUMBER_OTHERS = ['Country Code', 'DID', 'Operator', 'Number Routing', 'Linked DID'];
export const SAMPLE_DATA_OTHERS = [{ 'Country Code': 'IN', 'DID': '9991066739', 'Operator': 'JIO', 'Number Routing': 'incoming', 'Linked DID': '9991066700' }];
export const SAMPLE_DATA_OTHERS_UPDATE = [{ 'DID': '9991066739', 'Currency': 'INR', 'Country Code': 'IN', 'State Code': "HR", 'Operator': 'JIO', 'Status': "1", 'Number Routing': 'incoming' }];

export const ASSIGN_DID_VMN = ['DID', 'STATUS', 'VMN'];
export const ASSIGN_DID_TOLLFREE = ['DID', 'STATUS', 'TOLL FREE'];
export const UPLOAD_CONTACT_GROUP_MEMBERS = ['First Name(Required)', 'Last Name(Optional)', 'State(Optional)', 'City(Optional)', 'Country(Optional)', 'Company(Optional)', 'Street(Optional)', 'Primary Number(Required)', 'Alternate Number 1(Optional)', 'Alternate Number 2(Optional)'];
export const UPLOAD_CONTACT_GROUP_MEMBERS_DATA = [{ 'First Name(Required)': 'John', 'Last Name(Optional)': 'Smith', 'City(Optional)': 'Denmark', 'Country(Optional)': "Brazil", 'Street(Optional)': 'Corcovado Mountain', 'Primary Number(Required)': "1234567890", "Alternate Number 1(Optional)": "1234567891", "Alternate Number 2(Optional)": "1234567892", 'State(Optional)': "CVE", 'Company(Optional)': "Redeemers" }];



export const NUBMERS_STATUS_LABEL = ['Available', 'Blocked', 'Reserved', 'Archived', 'Terminated', 'Demo', 'Live', 'Delete', 'Pending', 'Reject']
export const API_DID_NUMBERS = 'numbers/did';


export const API_NUMBER_STATUS = 'numbers/number-status';


export const DATA_CENTER_DOMESTIC_TYPE = 0;
export const DATA_CENTER_INTERNATIONAL = 1;
export const DATA_CENTER_TYPES = [
  { label: "Domestic", value: DATA_CENTER_DOMESTIC_TYPE },
  { label: "International", value: DATA_CENTER_INTERNATIONAL },
];
export const DOMESTIC_COUNTRY = { label: "IN", value: "India" };

export const SERVER_MANAGEMENT_DOMESTIC_TYPE = 0;
export const SERVER_MANAGEMENT_INTERNATIONAL = 1;
export const SERVER_TYPES = [
  { label: "Domestic", value: SERVER_MANAGEMENT_DOMESTIC_TYPE },
  { label: "International", value: SERVER_MANAGEMENT_INTERNATIONAL },
];

export const PULSE_DURATION = [
  { label: "1 Sec", value: 1 },
  { label: "15 Sec", value: 15 },
  { label: "30 Sec", value: 30 },
  { label: "60 Sec", value: 60 },
];

export const PLAN_TYPE = [
  { label: "INBOUND", value: 'INBOUND' },
  { label: "OUTBOUND", value: 'OUTBOUND' },
  { label: "MISSED", value: 'MISSED' },
];

export const SHARED_LEG_TYPE = [
  { label: "Customer PSTN", value: "CUSTOMER_PSTN" },
  { label: "Agent PSTN", value: "AGENT_PSTN" },
  { label: "Agent WebRTC", value: "AGENT_WEBRTC" },
];

export const INBOUND_ONLY_LEG_TYPE = [
  { label: "AI Agent", value: "AI_AGENT" },
];

export const LEG_TYPE = [...SHARED_LEG_TYPE, ...INBOUND_ONLY_LEG_TYPE];

export const STATUS = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

export const USERS_ROLE = {
  role_sadmin: "Super Admin",
  role_reseller: "Reseller",
  role_cadmin: "Company User",
  role_ccadmin: "Callcentre Admin",
  role_ccteamlead: "Callcenter Team Lead",
  role_ccagent: "Callcentre Agent",
  role_sub_superadmin: "Sub SuperAdmin"
};

export const IVR_LABELS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '#'];
export const WEEK_DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
export const DEFAULT_SCHEDULE_START = "00:00";
export const DEFAULT_SCHEDULE_END = "23:59";
export const DEFAULT_TIME_SCHEDULE = {
  start_time: DEFAULT_SCHEDULE_START,
  end_time: DEFAULT_SCHEDULE_END,
  week_days: WEEK_DAYS,
};

export const CALL_CONNECT = {
  WEBSOCKET_HOST: "rtc.nspl.cloud",
  WEBSOCKET_PORT: 443,
  SIP_PORT: 443
}

// export const UPLOAD_BULK_AGENT_CREATE = ['Agent Name', 'Agent Number', 'Email ID', 'Extension ID', 'Username', 'Password', 'Access', 'Type', 'Description', 'Cli Option', 'Is Outbound Enabled', 'Masking', 'First Call Connect', 'ACL Settings ID', 'Account Type', 'Expiry Date'];
export const UPLOAD_BULK_AGENT_CREATE = ['Agent Name', 'Agent Number', 'Email ID', 'Extension ID', 'Username', 'Password', 'Access', 'Type', 'Description', 'Is Outbound Enabled', 'Masking', 'First Call Connect', 'ACL Settings ID', 'Account Type', 'Expiry Date'];
// export const UPLOAD_BULK_AGENT_CREATE_REQUIREMENTS = ['Required', 'Required', 'Required', 'Optional', 'Required', 'Required', 'Required', 'Required', 'Optional', 'Optional', 'Optional', 'Optional', 'Optional', 'Optional', 'Optional', 'Optional'];
export const UPLOAD_BULK_AGENT_CREATE_REQUIREMENTS = ['Required', 'Required', 'Required', 'Optional', 'Required', 'Required', 'Required', 'Required', 'Optional', 'Optional', 'Optional', 'Optional', 'Optional', 'Optional', 'Optional'];
export const UPLOAD_BULK_AGENT_CREATE_SAMPLE_DATE = [{ 'Agent Name': "Agent_Name", 'Agent Number': "1234567890", 'Email ID': "agent@mymail.com", 'Extension ID': "1", 'Username': "My_Agent_Username", 'Password': "AgnPass@123", 'Access': "Regular", 'Type': "Mobile,Soft Phone,WEBRTC", 'Description': "My_Agent_Description", 'Is Outbound Enabled': 'false', 'Masking': 'false', 'First Call Connect': 'agent', 'ACL Settings ID': '', 'Account Type': '0', 'Expiry Date': '2026-12-31' }];


export const RANDOM_CAPTCHA_VALUE = "abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHJKLMNOPQRSTUVWXYZ"
export const MODULE_ACL = {
  USERS: 'Users',
  BREAKS: 'Breaks',
  CALL_CENTRE: 'Call Centres List',
  COMPANY: 'Company List',
  CONTACT_GROUP: 'Contact Group',
  CONTACTS: 'Contacts',
  DISPOSITION_FORMS: 'Disposition Forms',
  DATA_CENTRE: 'Data Center',
  IVR: 'IVR',
  EXTENSION: 'Extension',
  GROUPS: 'Dialer Groups',
  AGENTS: 'Agents',
  CALL_GROUP: 'Call Group',
  PBX_MANAGEMENT: 'PBX Management',
  GATEWAY_MANAGEMENT: 'Gateway Management',
  TRUNKS: 'Trunks',
  LOCATIONS: 'Dialer Locations',
  WEBHOOK: 'Webhook',
  MODULE_LIST: 'Module List',
  ACL_SETTING_LIST: 'ACL Setting List',
  NUMBERS: 'Numbers',
  NUMBERS_OPERATION: 'Numbers Operation',
  REMARKS_STATUS: 'Remarks Status',
  AGENT_ANNOUNCEMENT: 'Agent Announcement',
  NOTIFICATION: 'Notification',
  CALL_SCRIPT : 'Call Script',
  RELEASE_CENTER: 'Release Center',
  VOICE_LIBRARY: 'Voice Library',
  SMS_WEBHOOK: 'SMS Webhook',
  API_WEBHOOK: 'API Webhook',
  TTS_PLANS: 'TTS Plans',
  DEMO_ACCOUNT_SETTINGS: 'Demo Account Settings',
  TTS: 'TTS',
  MANAGE_PROMPTS: 'Manage Prompts',
  MOH_MANAGEMENT: 'MOH Management',
  ACTIVITY_LIST: 'Activity List',
  AGENT_FILE_LIST: 'Agent File List',
  VOICE_PLANS: 'Voice Plans',
  FLASH_MESSAGE: 'Flash Message',
  CAMPAIGNS: 'Campaigns',
  CREDIT_HISTORY: 'Credit History',
  VOICEMAIL: 'Voicemail',
  SESSION_REPLAY: 'Session Replay',
  AGENT_LEADS: 'Agent Leads',
  REALTIME: 'Realtime',
  AI_AGENT: 'Ai Agent',
  RECORDINGS: 'Recordings',
  CALL_QUALITY_FEEDBACK: 'Call Audio Feedback',
}

/** ACL `module_name` keys from the API; override label only in UI (stored JSON keys unchanged). */
export const ACL_MODULE_DISPLAY_OVERRIDE = {
  Groups: 'Dialer Group',
};

export function getAclModuleDisplayLabel(moduleName) {
  if (moduleName == null || moduleName === '') return moduleName;
  return ACL_MODULE_DISPLAY_OVERRIDE[moduleName] ?? moduleName;
}

/** Modules that support only some ACL operations. The rest are hidden in the
 *  ACL grid and always saved as false. Modules not listed support all. */
export const ACL_MODULE_SUPPORTED_OPS = {
  [MODULE_ACL.RECORDINGS]: ['view_permission', 'read'],
  [MODULE_ACL.CALL_QUALITY_FEEDBACK]: ['view_permission', 'read', 'add'],
};

export function isAclOpSupported(moduleName, op) {
  const ops = ACL_MODULE_SUPPORTED_OPS[moduleName];
  return !ops || ops.includes(op);
}

export const DTMF_KEYS = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "*", "#"];
export const MAX_CONDITIONS = 5;

export const AI_AGENT_DESCRIPTION_CHAR_LIMIT = 300;


export const AI_AGENT_FIELD_LIMITS = {
  AGENT_NAME_MAX: 100,
  SYSTEM_PROMPT_MAX: 2500,
  GUARDRAILS_MAX: 1000,
  CONVERSATIONAL_FLOW_MAX: 1000,
  USER_INSTRUCTION_MAX_ITEMS: 5,
  USER_INSTRUCTION_MAX: 500,
  PERSONA_GREETING_MAX: 200,
  NEVER_SAY_MAX_ITEMS: 10,
  NEVER_SAY_MAX: 100,
  FOLLOWUP_MAX_ITEMS: 5,
  FOLLOWUP_MESSAGE_MAX: 200,
  FOLLOWUP_TIME_MIN: 5,
  FOLLOWUP_TIME_MAX: 60,
  DATA_VARIABLE_GROUPS_MAX_ITEMS: 5,
  DATA_VARIABLES_PER_GROUP_MAX_ITEMS: 20,
  DATA_VARIABLE_GROUP_NAME_MAX: 50,
  DATA_VARIABLE_KEY_MAX: 50,
  DATA_VARIABLE_DEFAULT_MAX: 200,
  COMPLETION_TYPE_MAX_ITEMS: 10,
  COMPLETION_TYPE_NAME_MAX: 50,
  API_MAX_ITEMS: 10,
  API_PARAMS_MAX_ITEMS: 15,
  API_NAME_MAX: 50,
  API_URL_MAX: 500,
  API_AUTH_VALUE_REF_MAX: 100,
  API_HEADERS_MAX_ITEMS: 10,
  API_HEADER_KEY_MAX: 50,
  API_HEADER_VALUE_MAX: 500,
  API_PARAM_NAME_MAX: 50,
  API_TIMEOUT_MIN: 1,
  API_TIMEOUT_MAX: 30,
  API_RETRY_MAX_ATTEMPTS_MIN: 0,
  API_RETRY_MAX_ATTEMPTS_MAX: 3,
  API_RETRY_BACKOFF_MIN: 1,
  API_RETRY_BACKOFF_MAX: 5,
  API_RESPONSE_PATH_MAX: 200,
  MCP_SERVERS_MAX_ITEMS: 5,
  MCP_NAME_MAX: 50,
  MCP_URL_MAX: 500,
};

export const ACTION_COLORS = {
  answer: "green",
  gather: "purple",
  hangup: "red",
  play: "#007bff",
  transfer: "orange",
  record: "#20c997",
  voicemail: "#6f42c1",
  missed: "#fd7e14",
  default: "#ffc107",
  api: "#17a2b8"
};
export const IVR_SETTING_ORDER = ["answer", "language", "play", "gather", "record", "hangup", "transfer", "voicemail", "missed", "api", "conditional", "aiAgent"];

export const VOICEMAIL_PROMPT_CATEGORIES = ["Welcome", "Thanks", "No Agent"];
export const VOICEMAIL_MAX_DURATION = 60;
export const VOICEMAIL_MIN_DURATION = 5;
export const TRANSFER_DEFAULT_OPTIONS = [
  { value: "hangup", label: "Hangup" },
  { value: "hangup_with_media", label: "Hangup with Media" },
  { value: "voicemail", label: "Voicemail" }
];
export const MISSED_NODE_OPTIONS = [
  { value: "hangup", label: "Hangup" },
  { value: "hangup_with_media", label: "Hangup with Media" },
  { value: "webhook", label: "Webhook" },
  { value: "sms_webhook", label: "SMS Webhook" },
  { value: "voicemail", label: "Voicemail" },
  { value: "set_callback", label: "Set Callback" }
];

// Seconds: 1-15 step 1, 20-60 step 5, then 5-30 min step 5 min.
const formatCallbackInterval = (seconds: number) =>
  seconds < 60 ? `${seconds} sec` : `${seconds / 60} min`;
export const CALLBACK_INTERVAL_OPTIONS = [
  ...Array.from({ length: 15 }, (_, i) => i + 1),
  ...Array.from({ length: 9 }, (_, i) => 20 + i * 5),
  ...Array.from({ length: 6 }, (_, i) => 300 + i * 300),
].map((value) => ({ value, label: formatCallbackInterval(value) }));
export const CALLBACK_RETRY_COUNT_OPTIONS = [1, 2, 3];
export const CALLBACK_DID_MODES = { SAME: "same", OTHER: "other" };
export const CALLBACK_DID_CATEGORIES = { FREE: "free", ROUTED: "routed" };
export const CALLBACK_ROUTING_ACTIONS = [
  { value: "ivr", label: "IVR" },
  { value: "agent", label: "Agent" },
  { value: "queue", label: "Call Group" },
  { value: "ai_agent", label: "AI Agent" }
];

export const FLASH_MESSAGE_ACTION =["Add", "Edit", "List", "Delete"]
export const FLASH_MESSAGE_TYPE = ["Flash Message", "Note"]

export const FLASH_MESSAGE_ACTION_OBJECT = {
  ADD: 'Add',
  EDIT: 'Edit',
  LIST: "List",
  DELETE: 'Delete'
}

export const HANGUP_CAUSES = [
  {id: 0, description: 'Cause not defined'},
  {id: 1, description: 'Unallocated (unassigned) number'},
  {id: 2, description: 'No route to specified transmit network'},
  {id: 3, description: 'No route to destination'},
  {id: 5, description: ' Misdialled trunk prefix (national use)'},
  {id: 6, description: 'Channel unacceptable'},
  {id: 7, description: 'Call awarded and being delivered in an established channel'},
  {id: 8, description: 'Preemption'},
  {id: 14, description: 'QoR: ported number'},
  {id: 16, description: 'Normal Clearing'},
  {id: 17, description: 'User busy'},
  {id: 18, description: 'No user responding'},
  {id: 19, description: 'No answer from user (user alerted)'},
  {id: 20, description: 'Subscriber absent'},
  {id: 21, description: 'Call Rejected'},
  {id: 22, description: 'Number changed'},
  {id: 23, description: 'Redirected to new destination'},
  {id: 26, description: 'Non-selected user clearing'},
  {id: 27, description: 'Destination out of order'},
  {id: 28, description: 'Invalid number format'},
  {id: 29, description: ' Facility rejected'},
  {id: 30, description: 'Response to STATUS ENQUIRY'},
  {id: 31, description: 'Normal, unspecified'},
  {id: 34, description: 'No circuit/channel available'},
  {id: 38, description: 'Network out of order'},
  {id: 41, description: 'Temporary failure'},
  {id: 42, description: 'Switching equipment congestion'},
  {id: 43, description: 'Access information discarded'},
  {id: 44, description: 'Requested circuit/channel not available'},
  {id: 50, description: 'Requested facility not subscribed'},
  {id: 52, description: 'Outgoing call barred'},
  {id: 54, description: 'Incoming call barred'},
  {id: 57, description: 'Bearer capability not authorized'},
  {id: 58, description: 'Bearer capability not presently available'},
  {id: 65, description: 'Bearer capability not implemented'},
  {id: 66, description: 'Channel type not implemented'},
  {id: 69, description: 'Requested facility not implemented'},
  {id: 81, description: 'Invalid call reference value'},
  {id: 88, description: 'Incompatible destination'},
  {id: 95, description: 'Invalid message unspecified'},
  {id: 96, description: 'Mandatory information element is missing	'},
  {id: 97, description: 'Message type non-existent or not implemented'},
  {id: 98, description: 'Message not compatible with call state or message type non-existent or not implemented'},
  {id: 99, description: 'nformation element nonexistent or not implemented'},
  {id: 100, description: 'Invalid information element contents'},
  {id: 101, description: 'Message not compatible with call state'},
  {id: 102, description: 'Recover on timer expiry'},
  {id: 103, description: 'Mandatory IE length error'},
  {id: 111, description: 'Protocol error, unspecified'},
  {id: 127, description: 'Interworking, unspecified'},
  {id: 411, description: 'Insufficient Channel Licence'},
  {id: 412, description: 'Assigned Call Center Not Found'},
  {id: 413, description: 'Agent Extension Not Found'},
  {id: 414, description: 'Out of Time Schedule'}
];

export const CAMPAIGN_TYPE_MAP = {
  "1": "Click2Call",
  "2": "Auto Dialer",
  "3": "Predictive Dialer",
  "4": "Power Dialer"
};


export const TEMPLATE_TYPE_MAP = {
  "0": "Simple IVR",
  "1": "DTMF",
  "2": "Call Patch",
  "3": "Custom IVR"
};

export const CUSTOMER_TRANSCRIPTION_ENABLED = true;

export const AGENT_SPEECH_LANGUAGES = [
  { code: "hi-IN", label: "Hindi" },
  { code: "en-IN", label: "English (India)" },
  { code: "en-US", label: "English (US)" },
  { code: "mr-IN", label: "Marathi" },
  { code: "gu-IN", label: "Gujarati" },
  { code: "bn-IN", label: "Bengali" },
  { code: "ta-IN", label: "Tamil" },
  { code: "te-IN", label: "Telugu" },
  { code: "kn-IN", label: "Kannada" },
  { code: "ml-IN", label: "Malayalam" },
  { code: "pa-Guru-IN", label: "Punjabi" },
  { code: "ur-IN", label: "Urdu" },
];

export const DEFAULT_AGENT_SPEECH_LANGUAGE = "hi-IN";

export const CUSTOMER_NATIVE_TRANSCRIPTION_ENABLED = true;

export const CUSTOMER_NATIVE_MIN_CHROMIUM_VERSION = 135;

export const CUSTOMER_NATIVE_BLOCK_EDGE = false;

export const CUSTOMER_NATIVE_SILENCE_RMS = 0.004;

export const CUSTOMER_NATIVE_LEAK_STRIKES = 2;

export const CUSTOMER_NATIVE_LEAK_WINDOW_MS = 4000;

export const CUSTOMER_NATIVE_PREFER_ON_DEVICE = true;

export const CUSTOMER_NATIVE_ON_DEVICE_QUALITY = "dictation";